module.exports = __webpack_public_path__ + "img/ys1.1fc3462f.png";